module.exports = __webpack_public_path__ + "static/media/inc.46da4baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/inc.png
// module id = 1799
// module chunks = 147